"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "ClipboardCheck___StyledSvg",
  componentId: "bqoxry-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function ClipboardCheck(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M169.397 84.783C177.56 53.392 205.918 30 239.848 30c33.928 0 62.286 23.394 70.449 54.783h20.855v36.523h36.521c20.141 0 36.521 16.397 36.521 36.521v255.652c0 20.141-16.38 36.521-36.521 36.521H112.021C91.88 450 75.5 433.62 75.5 413.479V157.827c0-20.122 16.378-36.521 36.521-36.521h36.521V84.783h20.855zm198.276 328.696V157.827h-36.521v36.521h-182.61v-36.521h-36.52v255.652h255.651zm-146.087-98.864l-41.871-41.872-25.822 25.82 67.694 67.712L325.8 262.042 299.98 236.22l-78.392 78.395zm-36.52-156.788H294.63v-36.521H185.065v36.521zm86.391-73.044c-6.319-10.92-18.116-18.26-31.609-18.26-13.497 0-25.292 7.34-31.628 18.26h63.237z"
  }));
}

var _default = ClipboardCheck;
exports["default"] = _default;